const MuiPopover = {
    paper: {
      width: 'auto !important',
      maxWidth: '30vw !important',
    },
  }
  
  export default MuiPopover
  